
module.exports = function(a, b){
  var fn = function(){};
  fn.prototype = b.prototype;
  a.prototype = new fn;
  a.prototype.constructor = a;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/component-inherit/index.js
// module id = ./node_modules/component-inherit/index.js
// module chunks = vendor